import styled from 'styled-components';
import { fromMd } from '../../../../constants/breakpoints';
import { deriveTextEmbroideryFontFamilyFromStyle } from '../../utils';
export const Body = styled.div `
  color: ${o => o.color.toLowerCase()};
  font-family: ${o => deriveTextEmbroideryFontFamilyFromStyle(o.fontStyle)};
  font-size: clamp(8px, 2vw, 32px);
  font-weight: bold;
  position: absolute;
  text-align: center;
  white-space: nowrap;
  z-index: ${o => o.theme.zIndex.foregroundContent};

  ${fromMd} {
    font-size: clamp(8px, 1vw, 32px);
  }
`;
export const Text = styled.span `
  display: block;
`;
//# sourceMappingURL=styles.js.map